module["exports"] = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Northwest Territories",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/state.js
// module id = 531
// module chunks = 0